import { getStore } from '../store/store';
import getTabIdFromWindow from '../utils/getTabIdFromWindow';

/**
 * Checks if the specified drawer pane is visible in the given window.
 * @param paneId - The ID of the drawer pane to check. If not provided, checks if any pane is active.
 * @param targetWindow - The window to check the visibility in. Defaults to the current window.
 * @returns True if the specified drawer pane is visible, false otherwise.
 */
export function isDrawerPaneVisible(paneId?: string, targetWindow?: Window): boolean {
    const tabId = getTabIdFromWindow(targetWindow);
    const activePane = getStore().activePanes.get(tabId);

    if (!paneId) {
        return !!activePane;
    }
    return activePane === paneId;
}
